export default {
  home: 'خانه',
  notFound: 'پیدا نشد',
  notFoundMessage: 'صفحه مورد نظر شما وجود ندارد',
};
